export default __webpack_public_path__ + "static/media/aws.94725a8c.svg";